import { render, staticRenderFns } from "./MainNavV2.vue?vue&type=template&id=53c108ad&scoped=true&"
import script from "./MainNavV2.vue?vue&type=script&lang=js&"
export * from "./MainNavV2.vue?vue&type=script&lang=js&"
import style0 from "./MainNavV2.vue?vue&type=style&index=0&id=53c108ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c108ad",
  null
  
)

export default component.exports